export default "__VITE_ASSET__f9ea9c95__"